import { z } from "zod";

export interface SelectOptionLookup<T = number> {
  id: T;
  text: string;
}

// Specific variants for common use cases
export interface NumericSelectOptionLookup extends SelectOptionLookup<number> {}
export interface StringSelectOptionLookup extends SelectOptionLookup<string> {}

export interface StateLookup {
  id: number;
  name?: string | null;
  code?: string | null;
  abbreviation?: string | null;
  fipsStateCode?: string | null;
}

export interface CountyLookup {
  id?: number | null;
  name?: string | null;
  code?: string | null;
  fipsCountyCode?: string | null;
  stateId?: number;
  state?: StateLookup | null;
}

export interface PermissionLookup {
  id: number;
  name: string;
  description: string;
  enabled: boolean;
  module: SelectOptionLookup;
}

export type ApiResult<T> = { data: T; error?: string | null };

export const idParam = z
  .string()
  .regex(/^[0-9]+$/, "Id must be numeric")
  .transform(Number);
